/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';

import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';

import FormularioUnidadesCV from './controladorVista/formularioUnidadesCV';
import TablaUnidadesCV from './controladorVista/tablaUnidadesCV';
import { estadoIncial, reductor } from './reductorUnidades';

const Unidades: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaUnidadesCV />
        <FormularioUnidadesCV />
    </ProveedorEstado>
);

export default Unidades;
